export const lists = {
  inventory: {
    columnNames: [
      'Ссылка',
      'Название',
      'Штрихкод',
      'Сущность',
      'Сохраненное количество',
      'Реальное количество',
    ],
    defaultRowNames: [
      'name',
      'barcode',
    ],
  },
  projects: {
    columnNames: [
      "Название",
      "Статус",
      "Дата сдачи",
      "Создан",
      "Обновлен",
      "Ответственный пользователь",
    ],
    rowNames: [
      "name",
      "status",
      "deadline_datetime",
      "created_at",
      "updated_at",
    ],
    orderFields: {
      "Имя": "name",
      "Статус": "status",
      "Создан": "created_at",
      "Ответственный пользователь": "user_id",
      "Дата сдачи": "deadline_datetime",
      "Обновлен": "updated_at",
    },
    rowLinks: {
      user: "login",
    },
    filterFields: [
      {
        name: "status",
        title: "Статус",
        value: "",
        selectOptions: [
          {
            label: "В работе",
            value: "в работе",
          },
          {
            label: "Отменен",
            value: "отменен",
          },
          {
            label: "Выполнен",
            value: "выполнен",
          },
        ],
      },
      {
        name: "size",
        title: "Размер",
        value: "",
      },
      {
        name: "deadline_datetime",
        title: "Срок сдачи",
        value: "",
        type: "date",
      },
    ],
  },
  stockEntity: {
    columnNames: [
      "Название",
      "Тип",
      "Артикул",
      "Штрихкод",
      "Создан",
      "Обновлен",
    ],
    rowNames: [
      "name",
      "type",
      "vendor_code",
      "barcode",
      "created_at",
      "updated_at",
    ],
    orderFields: {
      "Название": "name",
      "Тип": "type",
      "Артикул": "vendor_code",
      "Штрихкод": "barcode",
      "Создан": "created_at",
      "Обновлен": "updated_at",
    },
    tablesContent: {
      "/products": {
        buttonText: "Добавить продукт",
        title: "Продукты",
      },
      "/cloths": {
        buttonText: "Добавить ткань",
        title: "Ткани",
      },
      "/cut_of_clothes": {
        buttonText: "Добавить крой",
        title: "Крой",
      },
      "/sewing_accessories": {
        buttonText: "Добавить фурнитуру",
        title: "Фурнитура",
      },
      "/stationery": {
        buttonText: "Добавить канцелярию",
        title: "Канцелярия",
      },
      "/expendable_materials": {
        buttonText: "Добавить расходник",
        title: "Расходники",
      },
      "/packages": {
        buttonText: "Добавить упаковку",
        title: "Упаковки",
      },
      "/promotional_products": {
        buttonText: "Добавить рекламную продукцию",
        title: "Рекламная продукция",
      },
    },
    filterFields: [
      {
        name: "type",
        title: "Тип",
        value: "",
      },
      {
        name: "vendor_code",
        title: "Артикул",
        value: "",
      },
      {
        name: "barcode",
        title: "Штрихкод",
        value: "",
      },
    ],
  },
  stockOperations: {
    arrival: {
      list: {
        columnNames: [
          "Название",
          "Подтип",
          "Артикул",
          "Штрихкод",
          "Дата создания",
          "Количество",
        ],
      },
      modalWindow: {
        columnNames: ["Название", "Артикул", "Штрихкод", "Дата создания"],
      },
    },
  },
  stockMovement: {
    columnNames: [
      'Операция',
      'Количество',
      'Дата операции',
      'Описание',
      'Проект',
      'Наряд-заказ',
      'Компонент',
      'Успешно',
    ],
    orderFields: {
      'Операция': 'operation_name',
      'Количество': 'count',
      'Дата операции': 'created_at',
      'Описание': 'operation_description',
      'Наряд-заказ': 'purchase_order_id',
      'Проект': 'project_id',
      'Успешно': 'is_success',
    },
    filterFields: [
      {
        name: "operation_name",
        title: "Тип операции",
        value: "",
      },
      {
        name: "operation_description",
        title: "Описание",
        value: "",
      },
      {
        name: "is_success",
        title: "Статус",
        selectOptions: [
          {
            label: "Успешно",
            value: "1",
          },
          {
            label: "Провально",
            value: "0",
          },
        ],
      },
    ],
  },
  purchaseOrders: {
    columnNames: [
      'Номер',
      'Статус',
      'Создан',
      'Обновлен',
      'Дата отгрузки',
      'Дата факт.отгрузки',
      'Резерв',
      'Клиент',
    ],
    rowNames: [
      'number',
      'status',
      'created_at',
      'updated_at',
      'shipping_date',
      'actual_shipping_date',
      'was_reserved',
    ],
    orderFields: {
      'Номер': 'number',
      'Статус': 'status',
      'Создан': 'created_at',
      'Обновлен': 'updated_at',
      'Дата отгрузки': 'shipping_date',
      'Дата факт.отгрузки': 'actual_shipping_date',
      'Резерв': 'was_reserved',
      'Клиент': 'client_id',
    },
    rowLinks: {
      client: 'name',
    },
    filterFields: [
      {
        name: 'number',
        title: 'Номер',
        value: '',
      },
      {
        name: 'shipping_date',
        title: 'Дата отгрузки',
        value: '',
        type: 'date'
      },
      {
        name: 'actual_shipping_date',
        title: 'Дата факт.отгрузки',
        value: '',
        type: 'date'
      },
      {
        name: 'was_reserved',
        title: 'Резервирование',
        value: '',
        selectOptions: [
          {
            label: 'Есть',
            value: '1',
          },
          {
            label: 'Нет',
            value: '0',
          },
        ],
      },
      {
        name: 'status',
        title: 'Статус',
        value: '',
        selectOptions: [
          {
            label: 'В работе',
            value: 'в работе',
          },
          {
            label: 'Отменен',
            value: 'отменен',
          },
          {
            label: 'Выполнен',
            value: 'выполнен',
          },
        ],
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/stock/constants/tables.js